import { useOverlay } from './overlay'

export function useLayoutLoader() {
  const { close, isOpen } = useOverlay()

  function show() {
    isOpen.value = true
  }

  return {
    isActive: isOpen,
    show,
    hide: close,
  }
}
